/** Forme du catalogue publié par l'API sur le stockage objet. */

export interface MediaPublic {
  cle: string;
  libelle: string;
  description: string | null;
  type: string;
  extension: string;
  taille: number | null;
  ordre: number;
  url: string;
  urlVignette: string | null;
}

export interface RubriquePublique {
  id: number;
  libelle: string;
  medias: MediaPublic[];
}

export interface Catalogue {
  genereLe: string;
  rubriques: RubriquePublique[];
  nonClasses: MediaPublic[];
}

/**
 * Toutes les œuvres visibles, dans l'ordre — ce que montre la page d'accueil.
 *
 * L'ancien site appelait sa liste de médias SANS identifiant de rubrique au
 * chargement : la page d'accueil montrait donc l'ensemble, y compris les 24 œuvres
 * qui ne sont rattachées à aucune rubrique. Sélectionner la première rubrique
 * d'office, comme je le faisais, les faisait disparaître du site.
 */
export function toutesLesOeuvres(catalogue: Catalogue): MediaPublic[] {
  return [...catalogue.rubriques.flatMap((r) => r.medias), ...catalogue.nonClasses].sort(
    (a, b) => a.ordre - b.ordre,
  );
}

export const estVideo = (media: MediaPublic): boolean => media.type.startsWith('video/');
export const estImage = (media: MediaPublic): boolean => media.type.startsWith('image/');
